<script>
import { Line } from 'vue-chartjs'
import moment from 'moment'

export default {
  extends: Line,
  props: {
    'interface': '',
    deviceID: '',
    device: {
      type: String,
      default: ''
    },
    period: {
      type: String,
      default: 'D'
    },
  },
  data() {
    return {
      times: [],
      rx_bytes: [],
      tx_bytes: [],
      data: '',
      max_rx: 0.0,
      max_tx: 0.0,
    }
  },
  methods: {
    getData() {
      this.gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 300);
      this.gradient2 = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 300);

      this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
      this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
      this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

      this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
      this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
      this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

      // let uri = `/api/devices/${this.$route.params.id}/data?type=traffic&interface=${this.interface}&device=${this.device}&period=${this.period}`;
      let uri = `/api/devices/${this.deviceID}/data?type=traffic&interface=${this.interface}&device=${this.device}&period=${this.period}`;
      axios.get(uri)
        .then(response => {
          this.data = response.data.data;
          if (this.data) {
            this.data.forEach(element => {
              this.times.push(moment.utc(element.time).local().format('YYYY-MM-DD HH:mm:ss'));
              this.rx_bytes.push(element.rx);
              this.tx_bytes.push(element.tx);
            });

            // this.max_rx = Math.max.apply(Math, this.rx_bytes);
            // this.max_tx = Math.max.apply(Math, this.tx_bytes);

            this.renderChart({

              labels: this.times,
              datasets: [{
                label: "Inbound",
                borderColor: "#FC2525",
                pointBackgroundColor: "white",
                borderWidth: 1,
                pointBorderColor: "white",
                backgroundColor: this.gradient,
                data: this.rx_bytes,
                lineTension: 0.25
              }, {
                label: 'Outbound',

                borderColor: "#05CBE1",
                pointBackgroundColor: "white",
                pointBorderColor: "white",
                borderWidth: 1,
                backgroundColor: this.gradient2,
                data: this.tx_bytes,
                lineTension: 0.25
              }]
            }, {
              responsive: true,
              maintainAspectRatio: false,

              scales: {
                xAxes: [{
                  type: 'time',
                  distribution: 'linear',
                  time: {
                    displayFormats: {
                      quarter: 'MMM YYYY'
                    },

                    // parser: function(value) {
                    // return moment.unix(value).local();
                    // }

                  },
                  gridLines: {
                    display: false,
                    color: "black"
                  },
                  scaleLabel: {
                    display: false,
                    labelString: "Time",
                    fontColor: "#05CBE1"
                  },
                }],
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "GB",
                    fontColor: "#05CBE1"
                  },
                }]
              },

            })

          } else {
            console.log('NO DATA');
          }
        }).catch(error => {

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
          }
          // console.log(error.config);

        })

    },

  },

  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (this.times) this.rx_times = null;
    if (this.rx_bytes) this.rx_bytes = null;
    if (this.tx_bytes) this.tx_bytes = null;
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
</script>
